<script lang="ts">
  import editorInstance from '../../editor';
  import editorStore from '../../editor.store';
  import type {EditorActiveComponent} from '../../types';

  let item: EditorActiveComponent;
  const unmount = editorStore.subscribe(store => {
    item = store.activeComponent;
  });
  const duplicate = () => {
    editorInstance.history.addHistory('Duplicate');
    const newItem = item?.cloneNode(true) as HTMLElement;
    editorInstance.addComponent(newItem, true);
  };
</script>

<div
  on:click={duplicate}
  class="inline-block cursor-pointer rounded-lg p-2 text-gray-800 transition-all hover:bg-gray-100 hover:text-blue-600"
>
  <span class="fa-regular fa-copy" />
</div>
